import { protectedGet } from "./restUtil";

type StandardPingResponse = {
  user: {
    id: string;
  } | null;
  ping: "pong";
};

type AdminPingResponse = {
  user: {
    id: string | null;
  };
  premier_status: "pong";
  python: {
    long_version: string;
    version: string;
  };
  orm: {
    alembic: {
      version: string;
    };
    name: string;
    driver: string;
    version: string;
    schema: string;
  };
  version: string;
  host: {
    system: string;
    node: string;
    release: string;
    version: string;
    machine: string;
    processor: string;
  };
};

type PingResponse = StandardPingResponse | AdminPingResponse;

export function ping(
  onSuccess: (rs: PingResponse) => void,
  onError: (error: any) => void
) {
  return protectedGet("/ping", undefined, onSuccess, onError);
}
